<template>
    <div class="aside" :id="'aside_' + name" :class="{ 'is-active': isOpen }" :inert="!isOpen">
        <button class="close_aside" @click="closeAside()">
            &times;
        </button>
        <div class="aside_wrapper">
            <div class="aside_head">
                <!-- Add to cart message -->
                <div class="cart_message cross-selling" v-if="addToCartMessage">
                    <div class="image">
                        <lazy-img 
                            :image-url="'https://cdn.bio-kinder.de/frontend/images/icons/cart_success.svg'" 
                            :image-alt="'Erfolgreich hinzugefuegt'">
                        </lazy-img>
                    </div>
                    <div class="info-message">
                        <span class="success-info">
                            Erfolgreich zum Warenkorb hinzugefügt!
                        </span>
                    </div>
                    <div class="buttons">
                        <!-- <button v-toggle-basket-preview @click="closeAside()" aria-label="Schließen" class="btn btn-bkm-inverted close_aside">
                            Warenkorb
                        </button> -->
                        <a href="#" aria-label="Schließen" class="btn btn-bkm-inverted close_aside">
                            Schließen
                        </a>
                        <a :href="$ceres.urls.checkout" aria-label="Zur Kasse" class="btn btn-bkm">
                            {{ $translate("Ceres::Template.basketCheckout") }}
                            <i class="ml-2 fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
            
            <!-- Actual content -->
            <slot name="content">
                <div class="aside_content">
                    <component v-if="compiledComponentVisible" :is="compiledComponent"></component>
                </div>
                <loading-animation v-if="isLoading"></loading-animation>
            </slot>
        </div>
        <div class="aside_shadow" @click="closeAside()"></div>
    </div>
</template>

<script>
import ApiService from "../../services/ApiService";
import { isNullOrUndefined } from "../../helper/utils";

export default {
    props:
    {
        name: {
            type: String,
            default: null
        },
        categoryId: {
            type: Number,
            default: null
        },
        variationId: {
            type: Number,
            default: null
        },
        cartCrossSelling: {
            type: Boolean,
            default: false
        },
    },
    inject: {
        itemId: {
            default: null
        }
    },
    data(){
        return {
            contentLoaded: false,
            loadedContentId: null,
            isOpen: false,
            isLoading: false,
            isFailed: false,
            dynamicContent: "",
            compiledComponent: null,
            compiledComponentVisible: false,
            addToCartMessage: true
        }
    },
     created() {
        // Generate a unique ID if name not provided
        if (!this.name) {
            this.name = Math.random().toString(36).substr(2, 9);
        }
        this.$root.$on('toggle-aside', this.toggleAside);
        this.$root.$on('preload', this.preload);
        this.$root.$on('open-aside', this.openAside);
        this.$root.$on('close-aside', this.closeAside);
    },
    beforeDestroy() {
        this.$root.$off('toggle-aside', this.toggleAside);
        this.$root.$off('preload', this.preload);
        this.$root.$off('open-aside', this.openAside);
        this.$root.$off('close-aside', this.closeAside);
    },
    mounted() {
        this.$nextTick(() => {
            // this.contentLoaded = true;
        });
    },
    methods: {
        toggleAside(id) {
            if (id === this.name) {
                this.isOpen = !this.isOpen;
                this.$root.$emit('aside-toggled', this.isOpen);
            } else {
                this.isOpen = false;
            }
        },
        preload(id) {
            if(id === this.name && !this.isLoading && !this.contentLoaded)
            {
                this.requestContent()
            }
        },
        closeAside() {
            // always set all asides to "closed" when the close-aside event is triggered
            this.isOpen = false;
            this.$root.$emit('aside-toggled', this.isOpen);
        },
        openAside(id) {
            if(id === this.name)
            {
                this.isOpen = true;
                var data =  {
                    event: "toggleAside",
                    toggleAside: {
                        name: this.name,
                        itemId: this.itemId,
                        variationId: this.variationId,
                        categoryId: this.categoryId,
                        cartCrossSelling: this.cartCrossSelling
                    }
                };

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(data);
                this.$root.$emit('aside-toggled', this.isOpen);
            }
        },
        hideAddToCart()
        {
            this.addToCartMessage = false;
        },
        showAddToCart()
        {
            this.addToCartMessage = false;
        },
        requestContent()
        {
            let _this = this;
            this.isLoading = true;
            ApiService.get("/rest/io/shopbuilder", { categoryId: this.categoryId, templateType: null })
                .done((response) =>
                {
                    this.contentLoaded = true;
                    this.loadedContentId = this.categoryId;
                    if(response !== null && response.data !== null)
                    {
                        this.dynamicContent = response;
                        this.compileTemplate(response); // Compile the received content
                    } else {
                        this.isFailed = true;
                        console.info("Content could not be loaded", {'categoryId': _this.categoryId})
                    }
                })
                .fail(() =>
                {
                    this.contentLoaded = true;
                    this.isFailed = true;
                })
                .always(() => {
                    this.isLoading = false;
                });
        },
        compileTemplate(templateHtml) {
            if (!templateHtml) return;

            // Create a wrapper component with the received HTML
            this.compiledComponent = Vue.component(`dynamic-content-${this.name}`, {
                template: `<div>${templateHtml}</div>`
            });

            this.compiledComponentVisible = true;
        }
    },
    computed: {

        
    },
    watch: {
        isOpen: function(newVal)
        {
            if(newVal && !this.contentLoaded && !this.isLoading && !isNullOrUndefined(this.categoryId))
            {
                this.requestContent();
            }
        },
        categoryId: function(newVal)
        {
            if(this.contentLoaded && this.compiledComponent && !isNullOrUndefined(this.loadedContentId) && this.loadedContentId !== newVal)
            {
                this.compiledComponentVisible = false;
                this.compiledComponent = null;

                this.contentLoaded = false;
                this.loadedContentId = null;
                this.dynamicContent = "";

                this.requestContent();
            }
        }
    }
}
</script>